<template>
  <v-app
    id="inspire"
    class="bg-dark"
    :style="{
      backgroundImage: `linear-gradient(rgba(2, 2, 2, 0.75), rgba(0, 0, 0, 0.75)), url('${backgroundUrl}')`,
      backgroundSize: '100%',
      minHeight: '100vh'
    }"
  >
    <div id="challange-target">hidden</div>

    <v-container class="fill-height marginTop" fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <div class="row" v-for="rent in rental" :key="rent.id">
            <div class="col-md-6">
              <v-card elevation="24" class="mx-auto">
                <v-system-bar></v-system-bar>
                <v-carousel
                  cycle
                  hide-delimiter-background
                  delimiter-icon="mdi-minus"
                >
                  <v-carousel-item
                    @click="eventImages(rent.images)"
                    v-for="image in rent.images"
                    :key="image.id"
                    :src="image.image_path"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                  ></v-carousel-item>
                </v-carousel>

                <v-list>
                  <v-list-item>
                    <v-list-item-avatar>
                      <v-img
                        src="https://homemanagerfortesting.s3.amazonaws.com/360.png"
                      ></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>360 Admin</v-list-item-title>
                      <v-list-item-subtitle>Author</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action> </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card>
            </div>

            <!-- Modal -->
            <div
              class="modal fade bd-example-modal-lg"
              id="imageUp"
              tabindex="-1"
              role="dialog"
              aria-labelledby="addNewLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <v-carousel height="100%">
                    <v-carousel-item
                      v-for="img in imageArray"
                      :key="img.id"
                      :src="img.image_path"
                      reverse-transition="fade-transition"
                      transition="fade-transition"
                    ></v-carousel-item>
                  </v-carousel>
                </div>
              </div>
            </div>
            <!-- close modal  -->

            <div class="col-md-6">
              <v-card
                style="border-radius: 10px;"
                class="mx-auto"
                color="grey lighten-4"
              >
                <sequential-entrance tag="section">
                  <v-toolbar color="#01579B" class="top-hero6 mb-2" dark flat>
                    <v-toolbar-title> {{ rent.title }} </v-toolbar-title>
                  </v-toolbar>
                </sequential-entrance>

                <v-card-text class="pt-6" style="position: relative;">
                  <div class="font-weight-light grey--text title mb-2">
                    Price: ${{ rent.price }}
                    <span style="font-size: 0.7em"> Monthly </span>
                  </div>

                  <h3 class="display-1 font-weight-light blue--text mb-2">
                    {{ rent.address }}
                  </h3>

                  <v-divider></v-divider>
                  <div class="mb-2 text-center">
                    <v-chip class="mr-2"> State: {{ rent.state }} </v-chip>

                    <v-chip class="mr-2"> City: {{ rent.city }} </v-chip>

                    <v-chip class="mr-2">
                      Bathroom: {{ rent.bathroom }}
                    </v-chip>

                    <v-chip class="mr-2"> Bedroom: {{ rent.bedroom }} </v-chip>
                  </div>
                  <v-divider></v-divider>

                  <div class="font-weight-light title mb-2 shadow p-3">
                    <small><b>Description:</b></small
                    ><br />

                    <div>
                      <div class="descinline">
                        {{ rent.description | shortText(250) }} ..........
                      </div>
                      <div class="descempty">
                        <p style="white-space: pre-wrap;">
                          {{ rent.description }}
                        </p>
                      </div>
                      <a
                        class="linkCustom"
                        v-if="rent.description.length >= 250"
                        @click="toggler($event)"
                      >
                        Continue reading
                      </a>
                    </div>
                  </div>

                  <div class="font-weight-light title mb-2">
                    <small><b>Included Items:</b></small
                    ><br />
                    {{ rent.included_items }}
                  </div>
                  <v-divider></v-divider>

                  <sequential-entrance tag="section">
                    <div class="profile-card-ctr">
                      <v-btn
                        :href="rent.rental_application_path"
                        target="_blank"
                        class="profile-card__button button--blue"
                        dark
                        >Apply Now!</v-btn
                      >
                      <v-btn
                        @click="contact"
                        class="profile-card__button button--orange"
                        dark
                        >Contact 360 Real Estate</v-btn
                      >
                    </div>
                  </sequential-entrance>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      rental: [],
      backgroundUrl: "",
      imageArray: [],

      width: 300
    };
  },
  created() {
    this.getRental();
  },

  filters: {
    shortText(value, limit) {
      if (value) {
        return value.substring(0, limit);
      }
    }
  },

  methods: {
    getRental() {
      window.axios.get("/api/inventory/" + this.$route.params.id).then(res => {
        this.rental = res.data;
        this.backgroundUrl = this.backgroundUrl =
          res.data[0].images[0].image_path;
      });
    },

    eventImages(value) {
      this.imageArray = value;
      $("#imageUp").modal("show");
    },

    contact() {
      this.$router.push({ name: "Contact" });
    },

    toggler(e) {
      if (e.target.innerText == "Continue reading") {
        e.target.innerText = "Read Less";
        event.target.parentElement.children[0].className = "";
        event.target.parentElement.children[0].className = "descempty";
        event.target.parentElement.children[1].className = "";
        event.target.parentElement.children[1].className = "descinline";
      } else {
        e.target.innerText = "Continue reading";
        event.target.parentElement.children[0].className = "descinline";
        event.target.parentElement.children[1].className = "descempty";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.descempty {
  display: none;
}
.descinline {
  display: block;
}

.modal .modal-dialog {
  width: 100%;
  height: 100%;
  max-width: 95%;
  min-height: 100vh;
}
</style>
